<header role="banner">
  <div class="topbar">
    <nav class="nav-main-mobile" id="nav-main-mobile" role="navigation" vocab="http://schema.org/" typeof="SiteNavigationElement">
      <label class="nav-trigger" for="nav-main-mobile__check">
        <span class="nav-trigger__burger"><span class="nav-trigger__burger-inner"></span></span>
      </label>
      <input type="radio" class="nav-main-mobile__check" id="nav-main-mobile__check" name="nav-main-mobile__check" />
      <input type="radio" class="nav-main-mobile__check nav-main-mobile__check--uncheck" id="nav-main-mobile__uncheck" name="nav-main-mobile__check" />
      <div class="nav-main-mobile__offcanvas">
        <label for="nav-main-mobile__uncheck" id="nav-main-mobile__close-offcanvas" class="nav-main-mobile__close-offcanvas">{{'buttons.closeMenu' | translate}}</label>
        <div class="nav-main-mobile__link-list">  
          <div class="topbar__profile-menu">
            <app-profile-menu></app-profile-menu> 
          </div>       
        </div>     
      </div>
    </nav>

    <div class="grid-container grid-container--site-width">
      <div class="grid-column">
        <div class="topbar__inner">
          <div class="topbar__logo">
            <a href="/">
              <img class="logo" src="/assets/images/logo.png">
            </a>             
          </div>  
          
          <div class="topbar__profile-menu">
            <app-profile-menu></app-profile-menu>
          </div>
        </div>
      </div>
    </div>    
  </div>
</header>
